import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import ReactSelect from 'react-select'

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 10px;


  * {
    font-size: ${({ size }) => size === 'md' ? '16px' : '14px'};
    font-family: 'Open Sans';
    font-weight: 400;
    color: #555;
  }

  input[type='date'],
  input[type='time'] {
    -webkit-appearance: none;
  }

  .react-datepicker-wrapper {
    .form-control {
      color: 'red'
    }
  }
`

export const Label = styled.label`
  position: absolute;
  ${({ hasError }) => hasError && 'color: #C80E3B;'}
  top: -12px;
  font-size: 14px;
  left: 14px;
  margin: 0px;
  background: linear-gradient(0deg, rgba(255,255,255,0) 50%, rgba(255,255,255,1) 50%);
  padding: 4px;
  z-index: 1;
`

export const ErrorMessage = styled.p`
  color: #C80E3B;
  font-size: 13px;
  font-family: 'Open Sans';
  font-weight: 400;
  padding-left: 15px;
  margin: 0px;
`

export const renderSelectStyles = (override, hasError) => {
  return {
    placeholder: (provided) => {
      return {
        ...provided,
        marginLeft: 0,
        marginRight: 0,
        color: '#777'
      }
    },
    option: (provided, { isFocused }) => {
      return {
        ...provided,
        backgroundColor: isFocused ? '#D8EEF6' : null,
        color: '#777',
        zIndex: 2
      }
    },
    control: (provided) => ({
      ...provided,
      width: '100%',
      height: override?.height || '40px',
      border: hasError ? '2px solid #C80E3B' : '1px solid #999999',
      borderRadius: '8px',
      backgroundColor: '#fff',
      boxShadow: 'none',
      fontFamily: 'Open Sans',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: '400',
      lineHeight: 'normal',
      '&:hover': {
        borderColor: '#999999'
      }
    }),
    indicatorSeparator: () => ({
      display: 'none'
    }),
    dropdownIndicator: base => ({
      ...base,
      svg: {
        fill: '#777777',
        width: '16px',
        height: '16px'
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: 0,
      borderRadius: '0 0 8px 8px'
    })
  }
}

const Select = ({
  options = [],
  name,
  label = 'Escolha uma opção',
  onChange,
  selectedValue: initialValue,
  emptyLabel = 'Selecione uma opção',
  id = '',
  disabled = false,
  errorMessage,
  hookForm,
  hasTextInput = false,
  overrideStyles,
  size = 'sm'
}) => {
  const [selectedValue, setSelectedValue] = useState('')
  const hasError = !!errorMessage

  useEffect(() => {
    if (initialValue) {
      setSelectedValue(initialValue)
    }
  }, [initialValue])

  const handleSelectOption = selectedOption => {
    const value = selectedOption.value
    if (hookForm) {
      const syntheticEvent = { target: { name, value } }
      hookForm.onChange(syntheticEvent)
    }
    setSelectedValue(value)
    if (onChange) {
      onChange(value)
    }
  }

  return (
    <Container size={size}>
      {label && <Label hasError={hasError}>{label}</Label>}
      <ReactSelect
        {...hookForm}
        name={name}
        id={id}
        value={options.find((option) => option.value === selectedValue)}
        onChange={(option) => { handleSelectOption(option) }}
        isDisabled={disabled}
        placeholder={emptyLabel}
        options={options}
        styles={{ ...renderSelectStyles(overrideStyles, hasError) }}
        isSearchable={hasTextInput}
      />
      {hasError && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </Container>
  )
}

export default Select
